import { Component, OnInit } from '@angular/core';
import { CvBoxProductServiceService } from '../shared/services/cv-box-product-service.service';
import { ConfigurationService } from '../../shared/services/configuration.service';
import { LookupService } from '../../shared/services/lookup.service';
import { StoreService } from '../shared/services/store-service.service';
import { PagingFilter } from '../../shared/models/paging-filter.model';
import { CvBoxAccessTokenFilterModel } from '../shared/models/cv-box-access-token-filter-model';
import { StoreItemModel } from '../shared/models/store-item-model';
import { CvBoxAccessTokenModel } from '../shared/models/cv-box-access-token-model';
import { SelectItem, LazyLoadEvent } from 'primeng/api';
import { ProductType } from '../shared/models/product-type';
import { CvBoxAccessTokenStatus } from '../shared/models/cv-box-access-token-status.enum';
import { FeatureEnum } from '../../shared/models/feature-enum';
import { UserService } from '../../core/user.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cv-box-product-request-list',
  templateUrl: './cv-box-product-request-list.component.html',
  styleUrls: ['./cv-box-product-request-list.component.less'],
  standalone: false,
})
export class CvBoxProductRequestListComponent implements OnInit {
  public filterPagingWrapper: PagingFilter<CvBoxAccessTokenFilterModel>;
  public storeItems: StoreItemModel[];
  public cvBoxRequestList: CvBoxAccessTokenModel[];
  public totalRecords: number;
  public dateFormat: string;
  public specialDateFormat: string;
  public pageSize: number;

  public hasRequestApproveRejectPermission: boolean;
  public hasRequestTerminationPermission: boolean;

  public switchFilterStates: SelectItem[];

  public cvBoxAccessTokenStatusEnum = CvBoxAccessTokenStatus;

  constructor(
    private lookupService: LookupService,
    private config: ConfigurationService,
    private cvBoxProductServiceService: CvBoxProductServiceService,
    private userService: UserService,
    private storeService: StoreService,
    private translateService: TranslateService
  ) {
    this.hasRequestApproveRejectPermission = false;
    this.hasRequestTerminationPermission = false;

    this.filterPagingWrapper = new PagingFilter(
      new CvBoxAccessTokenFilterModel()
    );
    this.filterPagingWrapper.filter.statusIds = [
      CvBoxAccessTokenStatus.Pending,
    ];
    this.cvBoxRequestList = [];
    this.switchFilterStates = [
      {
        label: this.translateService.instant('label.Pending'),
        value: [CvBoxAccessTokenStatus.Pending],
      },
      {
        label: this.translateService.instant('label.Active'),
        value: [CvBoxAccessTokenStatus.Active],
      },
      {
        label: this.translateService.instant('label.Expired'),
        value: [
          CvBoxAccessTokenStatus.ReadOnly,
          CvBoxAccessTokenStatus.Expired,
        ],
      },
      {
        label: this.translateService.instant('label.Rejected'),
        value: [CvBoxAccessTokenStatus.Rejected],
      },
      {
        label: this.translateService.instant('label.Terminated'),
        value: [CvBoxAccessTokenStatus.Terminated],
      },
    ];
  }

  onLoad(event: LazyLoadEvent) {
    this.filterPagingWrapper.pagingInfo.start = event.first;
    this.filterPagingWrapper.pagingInfo.limit = event.rows;
    let filters: { [index: string]: any } = [];

    if (event.filters != null) {
      for (let f in event.filters) {
        {
          filters[f] = event.filters[f].value;
        }
      }
    }

    if (event.sortField && event.sortOrder) {
      this.filterPagingWrapper.sortParameters = [
        {
          column: event.sortField,
          order: event.sortOrder == 1 ? 'asc' : 'desc',
        },
      ];
    }

    this.filterPagingWrapper.filter.customer = filters['fullName'];
    this.onFilter();
  }

  onFilter() {
    this.cvBoxProductServiceService
      .listCvBoxRequests(this.filterPagingWrapper)
      .subscribe((d) => {
        this.cvBoxRequestList = d.items;
        this.totalRecords = d.totalCount;
      });
  }

  onApproveRequestClick(item: CvBoxAccessTokenModel) {
    if (confirm(this.translateService.instant('message.AreYouSure'))) {
      if (item.storeItemId !== item.storeItem.itemId) {
        this.cvBoxProductServiceService
          .approveCvBoxRequestWithModification(item, item.storeItemId)
          .subscribe((resp) => {
            this.onFilter();
          });
      } else {
        this.cvBoxProductServiceService
          .approveCvBoxRequest(item)
          .subscribe((resp) => {
            this.onFilter();
          });
      }
    }
  }

  onRejectRequestClick(item: CvBoxAccessTokenModel) {
    if (confirm(this.translateService.instant('message.AreYouSure'))) {
      this.cvBoxProductServiceService
        .rejectCvBoxRequest(item)
        .subscribe((resp) => {
          this.onFilter();
        });
    }
  }

  onRevokeRequestClick(result: any) {
    if (result.agree) {
      this.cvBoxProductServiceService
        .revokeCvBoxRequest(result.id, result.checked)
        .subscribe((resp) => {
          this.onFilter();
        });
    }
  }

  getSpecialDateFormat(format: string) {
    return format.replace('MM', 'mm').replace('yyyy', 'yy');
  }

  ngOnInit() {
    const config = this.config.getCachedConfig();
    this.pageSize = config.defaultPageSize;
    this.dateFormat = config.dateFormat;
    this.specialDateFormat = this.getSpecialDateFormat(this.dateFormat);

    const userFeatures = this.userService.currentUser.features;
    this.hasRequestApproveRejectPermission = userFeatures.some(
      (f) => f === FeatureEnum.ApproveRejectCvBoxProductRequest
    );
    this.hasRequestTerminationPermission = userFeatures.some(
      (f) => f === FeatureEnum.TerminateActiveCvBoxProduct
    );

    this.storeService.listStockItems(ProductType.CvBox).subscribe((resp) => {
      this.storeItems = resp.items;
    });
  }
}
